import _ from 'lodash';
import { dataServer } from '~/constants';
import RoleTypesIds from '~/containers/App/RoleTypes';
import { UPDATED_BY } from '~/containers/Reports/constants';
import type { Annotation } from '~/types/annotations';
import type { BridgeElement, Span, SubTask, Task } from '~/types/bridge';
import type { ElementData, ElementGroup, ElementType } from '~/types/defects';
import type { Survey } from '~/types/general';

export const generatePassword = (length: number) => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=';
    let password = '';
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };
export const isValidNumber = (val: string | number): boolean => {
  // console.log('val', val == "")
  let isValid = true;
  if (val === '-' || val === '' || isNaN(Number(val))) {
    isValid = false;
  }
  return isValid;
};
export const cleanObject = (obj: any): any => {
  if (!obj || typeof obj !== 'object') return obj;

  const cleaned: any = {};

  Object.keys(obj).forEach(key => {
    // Skip properties that start with 'field'
    if (key.toLowerCase().startsWith('field')) {
      return;
    }
    const value = obj[key];
    if (typeof value === 'string' && value.startsWith('{')) {
      return
    }

    // Only keep primitive values (string, number, boolean, null, undefined)
    if (
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean' ||
      value === null ||
      value === undefined
    ) {
      cleaned[key] = value;
    }
    // Skip arrays, objects, functions, etc.
  });

  return cleaned;
};
export const getLastCreateditem = (items: any[]) => [...items].sort((a, b) => b.id - a.id)[0];

export const getFileNameByString = (str: string, items: any[]) => items.filter(item => item.name.includes(str));

export const sortBy = (data: any[], field: string, reverse?: boolean) => {
  const array = [...data];
  if (reverse) {
    array.sort((a, b) =>
      a[field] < b[field] ? 1 : b[field] < a[field] ? -1 : 0,
    );
  } else {
    array.sort((a, b) =>
      a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0,
    );
  }
  //
  return array;
};
export const createSurveyTasksTree = (
  surveys: any[],
  bridgeTasks: any[],
  currentUserRole: any,

): any[] => {
  console.log("createSurveyTasksTree", currentUserRole);
  const tree = surveys
    // .filter((surv) => surv.id === displayedSurvey.id)
    .map((survey) => {
      const tasks = sortBy(
        bridgeTasks.filter((task) => task.survey_id === survey.id),
        'task_order'
      ).map((task) => {
        const showTask = currentUserRole && currentUserRole.role_type_id &&
          (currentUserRole.role_type_id === task.role_type_id || 
          currentUserRole.role_type_id === RoleTypesIds.Organization_admin ||
          currentUserRole.role_type_id === RoleTypesIds.Provider_Admin);
        return {
          ...task,
          disabled: !showTask,
          children: task.sub_tasks.map((subTask: any) => {
            // const showSubTask = currentUserRole.default_permitted_tasks.includes(subTask.name);
            return {
              ...subTask,
              parentTask: task,
              // disabled: !showSubTask,
            };
          }),
        };
      });
      return {
        ...survey,
        children: tasks,
      };
    });
  return tree;
};

export const getAnnotationsByImageName = (
  imageName: string,
  annotations: any[]): any[] => {
  const newAnnotations: any[] = [];
  annotations.forEach(
    ann =>
      ann.annotations &&
      ann.annotations.forEach((ann: any) => {
        const newAnnotation = { ...ann };
        newAnnotation.defect = ann;
        imageName.includes(ann.image_name) && newAnnotations.push(newAnnotation);
      }),
  );
  return newAnnotations;
};

export function getDataByField(
  data: any[],
  field: string,
  value: string | number
): BridgeElement[] {
  return data.filter((el: any) => (el as any)[field] == value);
}
export function getElementTypeBy(
  elements: BridgeElement[],
  field: string,
  value: string | number
): BridgeElement[] {
  return elements.filter((el: BridgeElement) => (el as any)[field] == value);
}

export function buildTreeDataByElementGroups(
  elementsGroups: ElementGroup[],
  elementTypes: ElementType[],
  bridgeElements: BridgeElement[]
): Array<any> {
  const treeData: any[] = [];

  elementsGroups.forEach(group => {
    const groupData = {
      name: group.name,
      type: 'group',
      id: group.group_number, // Use group_number as unique id
      // elements: getDataByField(bridgeElements, 'element_group_id', group.id),
      // elements: bridgeElements.filter(el => el.element_group_id === Number(group.group_number)),
      children: [] as any[],
    };
    const elementTypesByGroup = getDataByField(elementTypes, 'element_group_id', group.id)
    // elementTypes
    //   .filter(type => type.element_group_id == group.id)
    elementTypesByGroup.forEach(type => {
      const typeData = {
        name: type.name,
        type: 'elType',
        id: type.id,
        items: bridgeElements
          .filter(
            el =>
              el.element_group_id === group.id &&
              el.element_type_id === type.id
          )
          .map(element => ({
            ...element,
            type: 'element',
          })),
        children: [],
      };
      if (typeData.items.length) groupData.children.push(typeData);
    });
    if (groupData.children.length) treeData.push(groupData);
  });

  return treeData;
}
export function buildTreeDataBySpans(
  bridgeSpans: Span[],
  elementsGroups: ElementGroup[],
  elementsTypes: ElementType[],
  bridgeElements: BridgeElement[]
): Array<any> {
  const treeData: any[] = [];
  bridgeSpans
    .filter(span => bridgeElements.filter(el => el.span_id === span.id).length)
    .forEach(span => {
      const spanData = {
        name: span.name,
        type: 'span',
        id: span.id,
        // elements: bridgeElements.filter(el => el.span_id === span.id),
        children: [] as any[],
      };
      elementsGroups.forEach(group => {
        const groupData = {
          name: group.name,
          type: 'group',
          id: group.group_number, // Use group_number as id
          // elements: bridgeElements.filter(
          //   el => el.element_group_id === group.id && el.span_id === span.id
          // ),
          children: [] as any[],
        };
        elementsTypes
          .filter(type => type.element_group_id === group.id)
          .forEach(type => {
            const typeData = {
              name: type.name,
              type: 'elType',
              id: type.id,
              items: bridgeElements
                .filter(
                  el =>
                    el.element_group_id === group.id &&
                    el.element_type_id === type.id &&
                    el.span_id === span.id
                )
                // .sort((a, b) => a.object_id - b.object_id)
                .map(element => ({
                  ...element,
                  type: 'element',
                })),
              children: [],
            };
            if (typeData.items.length) groupData.children.push(typeData);
          });
        if (groupData.children.length) spanData.children.push(groupData);
      });
      treeData.push(spanData);
    });
  return treeData;
}

export const getUniqueValuesFromColumn = (field: string, data: any[]) => {
  //
  const uniqueValues: any[] = [];
  data.map(row => {
    if (
      row &&
      row[field] &&
      row[field] !== '' &&
      !uniqueValues.includes(row[field])
    )
      uniqueValues.push(row[field]);
  });
  //
  return uniqueValues;
};

export const isNumber = (value: any) =>
  typeof value === 'number' || (!isNaN(Number(value)) && value !== null && value !== '');
export function isDateValue(value: any): boolean {
  // Check if it's a Date object and valid
  if (value instanceof Date && !isNaN(value.getTime())) return true;

  // Check if it's a string that can be parsed to a valid date
  if (typeof value === 'string') {
    // First, check if it looks like a date format
    const datePatterns = [
      /^\d{4}-\d{2}-\d{2}$/,           // YYYY-MM-DD
      /^\d{2}\/\d{2}\/\d{4}$/,         // MM/DD/YYYY
      /^\d{2}-\d{2}-\d{4}$/,           // MM-DD-YYYY
      /^\d{4}\/\d{2}\/\d{2}$/,         // YYYY/MM/DD
      /^\d{1,2}\/\d{1,2}\/\d{4}$/,     // M/D/YYYY or MM/DD/YYYY
      /^\d{4}-\d{1,2}-\d{1,2}$/,       // YYYY-M-D or YYYY-MM-DD
      /^\w{3}\s+\d{1,2},?\s+\d{4}$/,   // Mon DD, YYYY or Mon DD YYYY
      /^\d{1,2}\s+\w{3}\s+\d{4}$/,     // DD Mon YYYY
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/ // ISO format
    ];

    // Check if the string matches common date patterns
    const looksLikeDate = datePatterns.some(pattern => pattern.test(value.trim()));

    if (!looksLikeDate) {
      return false;
    }

    // If it looks like a date, then try to parse it
    const d = new Date(value);
    return !isNaN(d.getTime());
  }

  return false;
}

export function parseJsonWithFixedControlChars(jsonString: string): any {
  // Check for bad control characters
  if (/[\u0000-\u001f]/.test(jsonString)) {
    // Replace bad control characters with their escaped equivalents
    jsonString = jsonString.replace(/[\u0000-\u001f]/g, function (match) {
      return `\\u${(`0000${match.charCodeAt(0).toString(16)}`).slice(-4)}`;
    });
  }
  // Parse the JSON string into a JavaScript object
  return JSON.parse(jsonString);
}

export const fixAndParseJson = (jsonString: string): any => {
  try {
    // console.log("fixAndParseJson", jsonString);
    // console.log(/[\u0000-\u001f]/.test(jsonString))
    if (/[\u0000-\u001f]/.test(jsonString)) {
      // Replace bad control characters with their escaped equivalents
      jsonString = jsonString.replace(/[\u0000-\u001f]/g, function (match) {
        return `\\u${(`0000${match.charCodeAt(0).toString(16)}`).slice(-4)}`;
      });
      return JSON.parse(jsonString);
    } else {
      for (let i = 0; i < jsonString.length; i++) {
        if (jsonString.charCodeAt(i) < 32) {
          // Replace bad control characters with their escaped equivalents
          jsonString = jsonString.replace(/[\u0000-\u001f]/g, function (match) {
            return `\\u${(`0000${match.charCodeAt(0).toString(16)}`).slice(-4)}`;
          });
          break;
        }
      }
      // If no bad control characters are found, parse the JSON string directly
      return JSON.parse(jsonString);
    }

  } catch (e) {
    console.error("Error fixing JSON string:", e);
    // If there's an error, return the original string or handle it as needed
    return null;
  }

  // Parse the JSON string into a JavaScript object

}

export function onlyUnique(value: any, index: number, self: any[]) {
  return self.indexOf(value) === index;
}

export const getUniqueByField = <T extends { [key: string]: any }>(field: string, data: T[]) => {
  const uniqueValues: any[] = [];
  const returnedData: T[] = [];
  data.forEach((item: T) => {
    if (item && item[field] && !uniqueValues.includes(item[field])) {
      uniqueValues.push(item[field]);
      returnedData.push(item);
    }
  });
  return returnedData;
};
export const getTotalExtentBySeverity = (elements: BridgeElement[], severity: string, imageAnnotations: Annotation[]) => {
  let total = 0;
  elements.forEach(element => {
    const annotations = imageAnnotations.filter(
      ann => ann.entity == element.object_id,
    );
    //
    annotations.forEach(ann => {
      if (ann.severity && ann.severity == severity) total += ann.extent;
    });
  });
  //
  return total.toFixed(2);
};
export const getTotalQuantity = (elements: any[]) => {
  let total = 0;
  elements.forEach(element => {
    if (element.primary_quantity) total += element.primary_quantity;
  });
  return total.toFixed(2);
};
export const sortByFields = (fields: string[], data: any[]) =>
  _.cloneDeep(data).sort(function (a, b) {
    // Sort by name
    fields.forEach(field => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
    });

    return 0; // names, age and city are equal
  });
export const getMinOfField = (fieldName: string, data: any[]) => {
  let min = data[0][fieldName];
  data.forEach(element => {
    if (element[fieldName] < min) min = element[fieldName];
  });
  return min;
};
export const getMaxOfField = (fieldName: string, data: any[]) => {
  let max = data[0][fieldName];
  data.forEach(element => {
    if (element[fieldName] > max) max = element[fieldName];
  });

  return max;
};

export const getSumOfField = (fieldName: string, data: any[]) => {
  let sum = 0;
  data.forEach(element => {
    sum += element[fieldName];
  });
  return sum;
};
export const calculateBridgeScs = (spans: any[]) => {
  let scs = 0;
  //
  const sumSpansArea = getSumOfField('span_area', spans);
  //
  spans.forEach(span => {
    scs += span.SCS * (span.span_area / sumSpansArea);
  });
  return scs;
};

export const calculateBridgeCpi = (spans: any[]) => {
  let cpi = 0;
  const sumSpansArea = getSumOfField('span_area', spans);
  spans.forEach(span => {
    cpi += span.CPI * (span.span_area / sumSpansArea);
  });
  return cpi;
};

export const calculateECSFromElements = (
  elements: any[],
  survey: Survey,
  severities: any,
  extents: any,
  imageAnnotations: any[]
): string => {
  const highestSeverities: any[] = [];
  let sumExtents = 0;
  let numExtents = 0;
  let ecs = 1;
  elements.forEach(el => {
    const elementsData = survey.elements_data;
    if (
      elementsData &&
      typeof elementsData === 'object' &&
      elementsData[String(el.object_id)] &&
      elementsData[String(el.object_id)].defectRating
    ) {
      const elementData = elementsData[String(el.object_id)];
      const defectRating = {
        ...elementData.defectRating,
      };
      delete defectRating[UPDATED_BY];
      // console.log({ defectRating, severities });
      const defectRatingSeverities = getSeveritiesFromElementDefectRating(
        defectRating,
        severities,
        imageAnnotations
      );
      highestSeverities.push(
        getHighestSeverityOfSeverities(defectRatingSeverities)
      );
      const defectRatingExtents = getExtentsFromElementDefectRating(
        defectRating,
        extents
      );
      sumExtents += getSumExtentsFromExtentsFactors(defectRatingExtents);
      numExtents += Object.keys(defectRating).length;
    }
  });
  if (highestSeverities.length) {
    const highestSeverity = getHighestSeverityOfSeverities(highestSeverities);
    const avgExtFactor = sumExtents / numExtents;
    if (highestSeverity) {
      ecs = highestSeverity.severity + avgExtFactor;
    }
  }
  return ecs.toFixed(2);
};

export const getSeveritiesFromElementDefectRating = (
  defectRating: any,
  severities: any[],
  imageAnnotations: any[]
): any[] =>
  Object.keys(defectRating)
    .map(defectCode => {
      // console.log(defectRating[defectCode]);
      if (
        defectRating[defectCode] &&
        defectRating[defectCode].severity &&
        defectRating[defectCode].severity.length
      ) {
        return defectRating[defectCode].severity;
      }
      const heighest = getHighesSeverityFromAnnotations(
        imageAnnotations.filter(ann => ann.defect_code == defectCode),
        severities
      );
      return heighest && heighest.description;
    })
    .map(sev => severities.find(severity => severity.description == sev));

export const getExtentsFromElementDefectRating = (
  defectRating: any,
  extents: any[]
): any[] =>
  Object.keys(defectRating)
    .map(defectCode => defectRating[defectCode].extent)
    .map(ext => extents.find(extent => extent.description == ext));

export const getHighesSeverityFromAnnotations = (
  annotations: any[],
  severities: any[]
): any => {
  const annotationsSeveritis = annotations.map(ann =>
    severities.find(severity => ann.severity == severity.description)
  );
  const uniqueSeverities = getUniqueValuesFromColumn(
    'severity',
    annotationsSeveritis
  ).sort();
  const highestSeverity = severities.find(
    sev => sev.severity == uniqueSeverities[uniqueSeverities.length - 1]
  );
  return highestSeverity;
};

export const getHighestSeverityOfSeverities = (severities: any[]): any => {
  let highestSeverityValue = 0;
  let highestSeverity;
  severities.forEach(sev => {
    if (sev && sev.severity > highestSeverityValue) {
      highestSeverityValue = sev.severity;
      highestSeverity = sev;
    }
  });
  return highestSeverity;
};

export const getSumExtentsFromExtentsFactors = (extents: any[]): number => {
  let sumExtentsFactor = 0;
  extents.forEach(ext => {
    if (ext && ext.ext_factor) sumExtentsFactor += ext.ext_factor;
  });
  return sumExtentsFactor;
};

export const getFileNameFromDirectoryPath = (path: string): string => {
  const parts = path.split('/');
  return parts[parts.length - 1];
}

export const getFolderAndFileName = (path: string) => {
  let folder = '';
  let fileName = '';
  if (path) {
    const parts = path.split('Images/');
    folder = parts[1];
    fileName = folder.split('/').pop() || '';
    folder = folder.replace(fileName, '');
  }

  return { folder, fileName };
}

export const extractJsonFromText = (text: string): any[] => {
            if (!text) return [];

            const jsonResults: any[] = [];

            try {
                const fullJson = JSON.parse(text.trim());
                jsonResults.push(fullJson);
                return jsonResults;
            } catch {
                // Continue to other methods
            }

            // Extract JSON from markdown code blocks
            const codeBlockRegex = /```(?:json|javascript|js)?\s*\n?([\s\S]*?)\n?```/gi;
            let match;

            while ((match = codeBlockRegex.exec(text)) !== null) {
                try {
                    const jsonContent = match[1].trim();
                    const parsed = JSON.parse(jsonContent);
                    jsonResults.push(parsed);
                } catch (error) {
                    console.warn("Failed to parse JSON from code block:", error);
                }
            }

            // Extract JSON objects/arrays using regex
            const jsonRegex = /(\{[\s\S]*?\}|\[[\s\S]*?\])/g;
            let jsonMatch;

            while ((jsonMatch = jsonRegex.exec(text)) !== null) {
                try {
                    const jsonString = jsonMatch[1];
                    if (jsonString.includes(':') || jsonString.includes('[')) {
                        const parsed = JSON.parse(jsonString);
                        if (!jsonResults.some(existing => JSON.stringify(existing) === JSON.stringify(parsed))) {
                            jsonResults.push(parsed);
                        }
                    }
                } catch (error) {
                    // Skip invalid JSON
                }
            }

            return jsonResults;
        };


export interface JsonIssue {
  /** Dot/bracket path to the offending value, e.g. "data.items[3].callback" */
  path: string;
  /** Why this value won't survive JSON serialization */
  reason: string;
  /** A short, printable description of the actual value */
  value: string;
}

const describeValue = (v: any): string => {
  const t = typeof v;
  if (t === 'function') return v.name ? `function ${v.name}` : 'anonymous function';
  if (t === 'symbol') return v.toString();
  if (t === 'bigint') return `${v.toString()}n`;
  if (t === 'number') return String(v); // NaN / Infinity / -Infinity
  if (t === 'undefined') return 'undefined';
  return t;
};

/**
 * Recursively walks `value` and collects every property that JSON.stringify
 * would drop or silently mutate, together with its full path in the structure.
 *
 * Detected problems:
 *  - undefined / function / symbol  (dropped from objects, become null in arrays)
 *  - NaN / Infinity / -Infinity     (become null)
 *  - BigInt                         (throws on stringify)
 *  - circular references            (throws on stringify)
 */
const collectJsonIssues = (
  value: any,
  path: string,
  seen: WeakSet<object>,
  issues: JsonIssue[],
): void => {
  const t = typeof value;

  if (value === null) return;

  if (t === 'undefined' || t === 'function' || t === 'symbol') {
    issues.push({
      path: path || '(root)',
      reason: `${t} is not valid JSON (will be omitted or replaced with null)`,
      value: describeValue(value),
    });
    return;
  }

  if (t === 'bigint') {
    issues.push({
      path: path || '(root)',
      reason: 'BigInt cannot be serialized to JSON (throws)',
      value: describeValue(value),
    });
    return;
  }

  if (t === 'number') {
    if (!Number.isFinite(value)) {
      issues.push({
        path: path || '(root)',
        reason: `${describeValue(value)} is not valid JSON (will be replaced with null)`,
        value: describeValue(value),
      });
    }
    return;
  }

  if (t !== 'object') return; // string, boolean — safe

  // Values that customize their own serialization are considered valid.
  if (typeof (value as any).toJSON === 'function') return;

  if (seen.has(value)) {
    issues.push({
      path: path || '(root)',
      reason: 'Circular reference (throws on serialization)',
      value: 'circular',
    });
    return;
  }
  seen.add(value);

  if (Array.isArray(value)) {
    value.forEach((item, i) => {
      collectJsonIssues(item, `${path}[${i}]`, seen, issues);
    });
  } else {
    for (const key of Object.keys(value)) {
      const childPath = path
        ? /^[A-Za-z_$][\w$]*$/.test(key)
          ? `${path}.${key}`
          : `${path}[${JSON.stringify(key)}]`
        : key;
      collectJsonIssues(value[key], childPath, seen, issues);
    }
  }

  seen.delete(value);
};

export const validateJson = (
  value: object | any[],
): { valid: boolean; error: string | null; issues: JsonIssue[], fixed: object | any[] } => {
  const issues: JsonIssue[] = [];
  try {
    collectJsonIssues(value, '', new WeakSet(), issues);

    if (issues.length > 0) {
      const summary = issues
        .map(i => `• ${i.path} — ${i.reason} (got: ${i.value})`)
        .join('\n');
      const fixed = fixUndefinedJson(value);
      return {
        valid: false,
        error: `Found ${issues.length} non-JSON-safe propert${issues.length === 1 ? 'y' : 'ies'}:\n${summary}`,
        issues,
        fixed
      };
    }

    return { valid: true, error: null, issues, fixed: value };
  } catch (e) {
    return { valid: false, error: (e as Error).message, issues, fixed: {} };
  }
};

/**
 * Recursively walks `value` and replaces every `undefined` with `""`,
 * including `undefined` items inside arrays and nested objects.
 * Returns a deep copy — the original input is not mutated.
 */
export const fixUndefinedJson = <T>(value: T, seen: WeakMap<object, any> = new WeakMap()): T => {
  if (value === undefined || value === null) {
    return '' as unknown as T;
  }

  if (value === null || typeof value !== 'object') {
    return value;
  }

  // Guard against circular references.
  if (seen.has(value as object)) {
    return seen.get(value as object);
  }

  if (Array.isArray(value)) {
    const copy: any[] = [];
    seen.set(value as object, copy);
    value.forEach(item => {
      copy.push(fixUndefinedJson(item, seen));
    });
    return copy as unknown as T;
  }

  const copy: Record<string, any> = {};
  seen.set(value as object, copy);
  for (const key of Object.keys(value as object)) {
    copy[key] = fixUndefinedJson((value as Record<string, any>)[key], seen);
  }
  return copy as unknown as T;
};

export const convertBytesToMb = (bytes: number): number => Number((bytes / (1024)).toFixed(2));

export const getFileExtension = (filename: string) =>
  filename.split('.').pop()?.toLowerCase() || '';

export const isAllowedFileType = (file: File, allowedTypes: string[]) => {
  console.log('isAllowedFileType', { file, allowedTypes });
  const ext = getFileExtension(file.name);
  return allowedTypes.includes(ext);
};export const convertToMySqlDateFormat = (date: Date) => {
  // 
  const d = new Date(date);
  const day = d.getDate();
  const month = d.getMonth()+1;
  const year = d.getFullYear();
  const hour = d.getHours();
  const min = d.getMinutes();
  const sec = d.getSeconds();
  const dateFormat = `${year}-${month}-${day} ${hour}:${min}:${sec}`

  return dateFormat
}

export const searchBy = (fieldName: string, value: any, orgs: any[], provs: any[], usersArray: any[]) => {
  const organization = orgs.find(org => org[fieldName] === value);
  const provider = provs.find(prov => prov[fieldName] === value);
  const user = usersArray.find(user => user[fieldName] === value);

  let results = null;
  if (organization || provider || user) {
    results = {
      organization,
      provider,
      user,
    };
  }
  return results;
};
  export const getEntities = async (field: string, value: string): Promise<any> => {

    const url = `${dataServer}entities/${field}/${encodeURIComponent(value)}`;
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        console.log('Response:', response);
       return response.json();

      })
      .catch(error => {
        console.error('Error fetching entities by email:', error);
  
        return [];
      });
  };
 export const getEntitiesBy = async(field: string, value: string) => {
    const url = `${dataServer}entities/${field}/${encodeURIComponent(value)}`;
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        console.log('Response:', response);
        return response.json();
      })
      .catch(error => {
        console.error('Error fetching entities by email:', error);
        return [];
      });
  };

    export const createSubTasksTable = (task: Task): SubTask[] => {

    if (task.sub_tasks) {
      if (typeof task.sub_tasks == 'string') {
        return JSON.parse(task.sub_tasks);
      }
      return task.sub_tasks;
    } else {
      const subTaskTable = [];
      if (task.sub_tasks_names) {
        const subTasks = task.sub_tasks_names && task.sub_tasks_names.split(',');
        const fileTypes = task.sub_tasks_file_types && task.sub_tasks_file_types.split(',');
        const completionDates = task.sub_tasks_dates && task.sub_tasks_dates.split(',');
  
        for (let index = 0; index < subTasks.length; index++) {
          subTaskTable.push({
            name: subTasks[index],
            fileType: fileTypes && fileTypes[index],
            completionDate: completionDates && completionDates[index],
            display_name: subTasks[index],
            updatedBy: '',
            description: '',
            task_description: '',
          });
        }
  
      }
  
      return subTaskTable;
  
    }
  };

  type VerificationError = {
  line: string;
  reason: string;
  lineNumber: number;
};

type VerificationResult = {
  verified: boolean;
  errors: VerificationError[];
  verifiedLines?: string[];
};

export const verifyFolderStructureCsvFile = (contentArray: string[]): VerificationResult => {
  let verified = true;
  const errors: VerificationError[] = [];
  const format = /[`!@#$%^&*+=\[\]{};':"\\|,.<>?~]/;

  contentArray.forEach((path, index) => {
    if (path.length && path.slice(-1) !== '/') {
      verified = false;
      errors.push({
        line: path,
        reason: 'Each path must end with "/"',
        lineNumber: index + 1,
      });
    }

    if (format.test(path)) {
      verified = false;
      errors.push({
        line: path,
        reason:
          "Path contains special charecters (`!@#$%^&*+=[]{};':\",.<>?~')",
        lineNumber: index + 1,
      });
    }
  });

  return {
    verified,
    errors,
  };
};

export const verifyCsvFile = (contentArray: string[], headers: string, numberFields: number[], requiredFields: number[]): VerificationResult => {
  const headersArray = headers.split(',');
  let verified = true;
  const errors: VerificationError[] = [];

  if (contentArray[0].toLowerCase() !== headers.toLowerCase()) {
    errors.push({
      line: contentArray[0],
      reason: `Headers must be ${headers}`,
      lineNumber: 1,
    });
    verified = false;
  }
  
  const verifiedLines: string[] = [];

  
  for (let i = 1; i < contentArray.length; i++) {
    let line = contentArray[i];
    if (line.slice(-1) === ',') {
      line = line.slice(0, -1);
    }
    
    if (line.length) {
      const lineArray = line.split(',');
      let isVerifiedLine = true;
      
      lineArray.forEach((field, index) => {
        if (requiredFields.includes(index)) {
          if (!field.length) {
            verified = false;
            isVerifiedLine = false;
            const existingError = errors.find(err => err.lineNumber === i);
            if (existingError) {
              existingError.reason += `, ${headersArray[index]} is empty`;
            } else {
              errors.push({
                line,
                reason: `${headersArray[index]} is empty`,
                lineNumber: i,
              });
            }
          }
        }
        
        if (numberFields.includes(index)) {
          if (isNaN(Number(field))) {
            verified = false;
            isVerifiedLine = false;
            const existingError = errors.find(err => err.lineNumber === i);
            if (existingError) {
              existingError.reason += `, ${headersArray[index]} is not a number`;
            } else {
              errors.push({
                line,
                reason: `${headersArray[index]} is not a number`,
                lineNumber: i,
              });
            }
          }
        }
      });
      
      if (isVerifiedLine) {
        verifiedLines.push(line);
      }
    }
  }
  
  return {
    verified,
    errors,
    verifiedLines,
  };
};
export const verifyImagesLocationCsvFile = (contentArray: string[]): VerificationResult => {
  const headers =
    'Pose_Id,x,y,z,Yaw,pitch,roll,ImagePath,image name,NearDepth,MedianDepth,FarDepth,Photogroup_Id,FocalLength,SensorSize,type';
    const numberFields = [1, 2, 3, 4, 5, 6, 9, 10, 11, 13, 14];
  const requiredFields = [1, 2, 3, 7];
  return verifyCsvFile(contentArray, headers, numberFields, requiredFields);

};
export const verifyElementsCsvFile = (contentArray: string[]): VerificationResult => {
  const headers =
    'object_id,name,importance,primary_unit,primary_quantity,secondary_unit,secondary_quantity,detailed_evaluation_required,remarks';
      const numberFields = [4, 6];
  const requiredFields = [0,1];
  
  return verifyCsvFile(contentArray, headers, numberFields, requiredFields);
};

export const taskCompletedPercentage = (subTasks: SubTask[]) => {
  const completed = [];
  subTasks.forEach(subTask => {
    if (subTask.completionDate) completed.push(subTask);
  });
  return Math.floor((completed.length / subTasks.length) * 100);
};
export const surveyCompletedPercentage = (survey: Survey) => {
    let total = 0;
    survey.children && survey.children.forEach((task: Task) => (total += task.completed));
    return Math.floor(total / (survey.children ? survey.children.length : 1));
  };

 export const createElementsData = (bridgeElements: BridgeElement[]) => {
    const elementsData: Record<string, ElementData> = {};
    bridgeElements.forEach(el => {
      elementsData[el.name] = {
        status: 'Open',
        remarks: '',
        needsAttention: false,
      };
    });
    return elementsData;
    // props.onUpdateSurveyField('elements_data', elementsData, props.survey.id);
  };
 